import React, { useState } from 'react';
import Header from '../components/Header';
import NavigationMenu from '../components/NavigationMenu';
import Card from '../components/Card';
import { FileTextIcon, FileIcon, FileImageIcon, FileVideoIcon, DownloadIcon, SearchIcon } from 'lucide-react';
const DocumentRepository = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };
  // Sample documents data
  const documents = [{
    id: 'D001',
    name: 'Manual de procedimientos.pdf',
    type: 'pdf',
    date: '2023-05-15',
    size: '2.5 MB'
  }, {
    id: 'D002',
    name: 'Presentación comercial.pptx',
    type: 'presentation',
    date: '2023-05-10',
    size: '4.1 MB'
  }, {
    id: 'D003',
    name: 'Tutorial simulador.mp4',
    type: 'video',
    date: '2023-05-05',
    size: '15.8 MB'
  }, {
    id: 'D004',
    name: 'Formato acuerdos.docx',
    type: 'document',
    date: '2023-05-01',
    size: '1.2 MB'
  }];
  const filteredDocuments = documents.filter(doc => doc.name.toLowerCase().includes(searchTerm.toLowerCase()));
  const getFileIcon = (type: string) => {
    switch (type) {
      case 'pdf':
        return <FileTextIcon size={24} className="text-red-500" data-id="element-121" />;
      case 'presentation':
        return <FileImageIcon size={24} className="text-amber-500" data-id="element-122" />;
      case 'video':
        return <FileVideoIcon size={24} className="text-blue-500" data-id="element-123" />;
      default:
        return <FileIcon size={24} className="text-gray-500" data-id="element-124" />;
    }
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-125">
      <Header username="Carlos Pérez" onMenuClick={handleMenuToggle} notificationCount={3} data-id="element-126" />
      <NavigationMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-127" />
      <main className="p-4 pb-20" data-id="element-128">
        <h1 className="text-xl font-semibold mb-4" data-id="element-129">Repositorio Documental</h1>
        {/* Search */}
        <div className="relative mb-6" data-id="element-130">
          <input type="text" placeholder="Buscar documentos..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-131" />
          <SearchIcon size={20} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-132" />
        </div>
        {/* Category tabs */}
        <div className="mb-6" data-id="element-133">
          <div className="flex space-x-2 overflow-x-auto pb-2" data-id="element-134">
            <button className="px-4 py-2 bg-blue-600 text-white rounded-lg whitespace-nowrap" data-id="element-135">
              Todos
            </button>
            <button className="px-4 py-2 bg-white border border-gray-300 rounded-lg whitespace-nowrap" data-id="element-136">
              PDF
            </button>
            <button className="px-4 py-2 bg-white border border-gray-300 rounded-lg whitespace-nowrap" data-id="element-137">
              Presentaciones
            </button>
            <button className="px-4 py-2 bg-white border border-gray-300 rounded-lg whitespace-nowrap" data-id="element-138">
              Videos
            </button>
          </div>
        </div>
        {/* Documents List */}
        <div className="space-y-4" data-id="element-139">
          {filteredDocuments.map(document => <Card key={document.id} className="flex items-center" data-id="element-140">
              <div className="mr-3" data-id="element-141">{getFileIcon(document.type)}</div>
              <div className="flex-1" data-id="element-142">
                <h3 className="font-medium" data-id="element-143">{document.name}</h3>
                <div className="flex text-xs text-gray-500 mt-1" data-id="element-144">
                  <span className="mr-3" data-id="element-145">{document.date}</span>
                  <span data-id="element-146">{document.size}</span>
                </div>
              </div>
              <button className="p-2 text-blue-600 hover:bg-blue-50 rounded-full" data-id="element-147">
                <DownloadIcon size={20} data-id="element-148" />
              </button>
            </Card>)}
        </div>
      </main>
    </div>;
};
export default DocumentRepository;